module.exports = __webpack_public_path__ + "img/egg_right.58008e29.png";